import { render, staticRenderFns } from "./HIK_exchange_platform-modal.vue?vue&type=template&id=3d804618&scoped=true"
import script from "./HIK_exchange_platform-modal.vue?vue&type=script&lang=js"
export * from "./HIK_exchange_platform-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d804618",
  null
  
)

export default component.exports